import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "stats-item-value",
  ref: "root"
}
const _hoisted_2 = {
  key: 0,
  class: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_count_to = _resolveComponent("count-to")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isAnimated)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.prefix) + " 0 " + _toDisplayString(_ctx.suffix), 1))
      : (_openBlock(), _createBlock(_component_count_to, {
          key: 1,
          "end-val": _ctx.parseValue(_ctx.value),
          suffix: _ctx.suffix,
          decimals: _ctx.decimals,
          prefix: _ctx.parsePrefix(_ctx.prefix),
          decimal: ",",
          separator: "",
          duration: 2500
        }, null, 8, ["end-val", "suffix", "decimals", "prefix"]))
  ], 512))
}